export default __webpack_public_path__ + "static/media/warning.b554769b.svg";